<template>
  <div class="page page-autumn-course">
    <ym-iframe class="ym-iframe"
               :src="render.pageUrl"
               v-if="render.pageUrl !== ''"
    />
    <contact-info :wx-path="contactInfo.wxSrc"
                  :mini-path="contactInfo.miniSrc"
                  v-if="contactInfo"
    />
  </div>
</template>

<script>
  import getAutumnCourseInfo from '@/services/autumn-course';
  import YmIframe from '@/components/YmIframe';
  import ContactInfo from '@/components/YmPcContactInfo';

  export default {
    name: 'AutumnCourse',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      YmIframe,
      ContactInfo,
    },
    data() {
      return {
        render: {
          pageTitle: '',
          pageUrl: '',
        },
        contactInfo: null,
      };
    },
    methods: {
      async fetchData() {
        const data = await getAutumnCourseInfo();
        this.render = data.render;
        this.contactInfo = data.contactInfo;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-autumn-course {
    height: 100%;
    color: #fff;
  }

  /deep/ .ym-iframe {
    overflow: hidden;
    height: 100%;
  }

</style>
